import type { ClientOwedStatus } from '../types';

/**
 * Whether a client's obligation lifecycle takes it OFF the dashboard's "Needs attention" (FB-2, 2026-10-26).
 *
 * - **closed** (every obligation cancelled or deactivated): nothing is owed.
 * - **ended**: owed through the period containing `finalEnd` (EndDate ends FUTURE periods, never the one in flight), so
 *   the client drops off only once filing health covers that month (`lastFiledMonth`, the latest calendar month a filed
 *   period covers).
 * - **open**, a missing status, or anything unparseable: still owed. The fail-safe is to keep showing the client.
 */
export function owesNothingNow(status: ClientOwedStatus | undefined, lastFiledMonth: string | undefined): boolean {
  if (!status) return false;
  if (status.state === 'closed') return true;
  if (status.state !== 'ended' || !status.finalEnd || !lastFiledMonth) return false;
  const endMonth = status.finalEnd.slice(0, 7);
  const filedMonth = lastFiledMonth.slice(0, 7);
  return /^\d{4}-\d{2}$/.test(endMonth) && /^\d{4}-\d{2}$/.test(filedMonth) && filedMonth >= endMonth;
}
